<template>
    <div>
        <!-- Tên -->
        <div class="nav_content_info_user">
            <h2 class="title_info_user">{{$t('personSet.editInfoUser')}}</h2>
        </div>
        <!-- Tên -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('personSet.userName')}}</label>
            <span class="" style="width:59%">
                <label>
                    <input
                        :placeholder="$t('personSet.enterName')"
                        class="input-info"
                        maxlength="20"
                        v-model="user_info.userName"
                        disabled
                    />
                </label>
            </span>
        </div>
        <!-- Năm sinh -->
        <div class="user_info_details user_info_details_bỉthday">
            <label class="user_info_details_name" style="width:40%">{{$t('personSet.birthday')}}</label>
            <span class="" style="width:59%">
                <label>
                    <el-date-picker 
                        value-format="yyyy-MM-dd" 
                        type="date"
                        style="width:100%!important"
                        v-model="user_info.birthDay"
                        disabled 
                    >
                    </el-date-picker>
                </label>
            </span>
        </div>
        <!-- Giới tính -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('manage.sex')}}</label>
            <span class="" style="width:59%">
                <label>
                    <div class="select-new">
                    <select v-model="user_info.gender" :class="{my_select_birthday_disabled:user_info.gender==''}" class="my_select">
                        <option 
                            class="ds"
                            value=""
                        >
                            {{$t('personSet.enterSex')}}
                        </option>
                        <option 
                            class="ds"
                            value="1"
                        >
                            {{$t('manage_student.male')}}
                        </option>
                        <option 
                            class="ds"
                            value="2"
                        >
                            {{$t('manage_student.female')}}
                        </option>
                    </select>
                    </div>
                </label>
            </span>
        </div>
        <!-- Thông tin liên lạc -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('manage_student.mobile')}}</label>
            <span class="" style="width:59%">
                <label>
                    <input
                        :placeholder="$t('personSet.enterMobile')"
                        class="input-info"
                        maxlength="50"
                        v-model="user_info.mobile"
                    />
                </label>
            </span>
        </div>
        <!-- Nghề nghiệp -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('personSet.occupation')}}</label>
            <span class="" style="width:59%">
                <label>
                    <input
                        :placeholder="$t('personSet.enterJob')"
                        class="input-info"
                        maxlength="20"
                        v-model="user_info.job"
                    />
                </label>
            </span>
        </div>
        <!-- Ngôn ngữ -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('aicourse.courseLanguage')}}</label>
            <span class="" style="width:59%">
                <label>
                    <div class="select-new">
                        <select v-model="user_info.area" class="my_select">
                            <option 
                                v-for="item in user_info.areaList" 
                                :key="item.value" 
                                :value="item.value"
                            >
                                {{item.label}}
                            </option>
                        </select>
                    </div>
                </label>
            </span>
        </div>
        <!-- Giới thiệu -->
        <div class="user_info_details">
            <label class="user_info_details_name" style="width:40%">{{$t('manage.discription')}}</label>
            <span class="" style="width:59%">
                <label>
                    <textarea
                        v-model="user_info.studentSynopsis"
                        :placeholder="$t('personSet.enterSynopsis')"
                        maxlength="200"
                    ></textarea>
                </label>
            </span>
        </div>
        <div class="btn-infouser">
            <button @click="saveUpdate()">{{$t('personSet.save')}}</button>
            <button @click="cancel()">{{$t('personSet.off')}}</button>
        </div>
        <loading :showLoading="showLoadingFlg" />
    </div>
</template>
<script>
import loading from "@/components/loading/loading";
export default {
    components: {
        loading
    },
    props: {
      data: {
        type:Object,
        default: {}
      },
    },
    data() {
        return {
            user_info: {},
            showLoadingFlg: false,
        };
    },
    created() {},
    beforeDestroy() {},
    mounted() {
        this.user_info = this.data;
    },
    methods: {
        saveUpdate(){
            /// Check không nhập tên 
            let dataReg = /^[1-9]\d{3}.(0[1-9]|1[0-2]).(0[1-9]|[1-2][0-9]|3[0-1])$/;
            if (this.user_info.userName == undefined || this.user_info.userName == null || this.user_info.userName == "") {
                this.$message.warning(window.vm.$i18n.t("js.userNameNull"));
                return;
            }
            /// check space user name
            let checkDataUsserName = /^\s+$/;
            if (checkDataUsserName.test(this.user_info.userName)) {
                this.$message.warning(window.vm.$i18n.t("js.userNameNull"));
                return;
            }
            if (this.user_info.enrollmentTime) {
                if (!dataReg.test(this.user_info.enrollmentTime)) {
                this.$el_alert_type("入学时间格式为YYYY/MM/DD", "warning");
                return;
                }
            }
            if (this.user_info.graduationTime) {
                if (!dataReg.test(this.user_info.graduationTime)) {
                this.$el_alert_type("毕业时间格式为YYYY/MM/DD", "warning");
                return;
                }
            }
            /// check input chỉ có space thì trả về trống
            /// Thông tin liên lạc
            if (checkDataUsserName.test(this.user_info.mobile)) {
                this.user_info.mobile = "";
            }
            /// Nghê nghiệp
            if (checkDataUsserName.test(this.user_info.job)) {
                this.user_info.job = "";
            }
            /// Giới thiệu
            if (checkDataUsserName.test(this.user_info.studentSynopsis)) {
                this.user_info.studentSynopsis = "";
            }
            this.showLoadingFlg = true;
            this.$api
                .post("/personalCenter/updatePersonalInfo", this.user_info)
                .then(() => {
                    this.$el_alert_type(window.vm.$i18n.t("js.saveSuccess"), "success");
                    window.sessionStorage.setItem("name", this.user_info.userName)
                    this.$api.post("/personalCenter/updateArea", this.user_info).then(() => {});
                    this.showLoadingFlg = false;
                    window.sessionStorage.setItem("gender", this.user_info.gender);
                    this.$emit("clickNextPageDetailsBtnUpdate", true);
                    this.$emit("clickTypeGender", this.user_info.gender);
                });
        },
        cancel(){
            this.$emit("clickNextPageDetailsBtnCancel", true);
        },
    },
};
</script>
<style scoped>
    .btn-infouser button{
        float: right;
        /* margin-top: 5px; */
        /* margin-bottom: 5px; */
        padding: 10px;
        border-radius: 5px;
        border: 0;
        background: #0071c5;
        color: #fff;
        margin-left: 10px;
    }
    .btn-infouser button:hover {
        background: #007aff!important;
    }
    .nav_content_info_user {
        text-align: center;        
    }
    .input-info {
        color: #606266;
        height: 40px;
        line-height: 3;
        padding: 0 15px;
        width: 100%;
        border: 1px solid #C0C4CC;
        background: #fff;
        border-radius: 4px;
    }
    .user_info_details{
        display: flex;
        /* justify-content: space-between; */
        padding: 1vh 2vh;
    }
    .user_info_details_name {
        font-size: 13px;
        font-weight: 700;
        width: 350px;
    }
    .user_info_details_info {
        font-size: 13px;
    }
    textarea {
        margin-top: 2px;
        margin-right: 1px;
        width: 100%;
        max-width: 100%;
        min-width: 100%;
        height: 75px;
        line-height: 20px;
        background-color: #fff;
        border-radius: 5px;
        font-size: 13px;
        color: #0f0f0f;
        text-align: left;
        border: 1;
        outline: none;
        padding-left: 8px;
        padding-right: 8px;
        resize: none;
        border: 1px solid #C0C4CC;
    }
    textarea:focus {
        color: #363030;
    }
    textarea::-webkit-input-placeholder {
        color: #e8e6e6;
    }
    textarea::-moz-placeholder {
        color: #e8e6e6;
    }
    textarea:-moz-placeholder {
        color: #e8e6e6;
    }
    textarea:-ms-input-placeholder {
        color: #e8e6e6;
    }
    @media (max-width: 480px) {
        .user_info_details{
            padding: 10px 0px!important;
        }
    }
    .title_info_user {
        color: #0071c5;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .my_select_birthday_disabled {
        color: #c9cccc;
    }
    .my_select_birthday_disabled .ds{
        color: #202122!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/personSet/infoUser/detailsInfo/updateInfo.vue